/* Datitia — reproduz o vídeo de hover do card de produto ao passar o mouse/focar.
   Delegado no document para funcionar também em grades recarregadas via AJAX
   (filtros, paginação infinita, quick view). */
(function () {
  function play(card) {
    var video = card.querySelector('.card__hover-video');
    if (!video) return;
    if (video.readyState === 0) video.load();
    video.play().catch(function () {});
  }

  function stop(card) {
    var video = card.querySelector('.card__hover-video');
    if (!video) return;
    video.pause();
    video.currentTime = 0;
  }

  document.addEventListener('mouseover', function (event) {
    var card = event.target.closest('.card-wrapper');
    if (!card || card.contains(event.relatedTarget)) return;
    play(card);
  });

  document.addEventListener('mouseout', function (event) {
    var card = event.target.closest('.card-wrapper');
    if (!card || card.contains(event.relatedTarget)) return;
    stop(card);
  });

  document.addEventListener('focusin', function (event) {
    var card = event.target.closest('.card-wrapper');
    if (card) play(card);
  });

  document.addEventListener('focusout', function (event) {
    var card = event.target.closest('.card-wrapper');
    if (card && !card.contains(event.relatedTarget)) stop(card);
  });
})();
